module.exports = __webpack_public_path__ + "img/logo-videomedi-white.f7dec0d3.png";